import { Box } from '@chakra-ui/react';
import { FC } from 'react';

import { ChildrenType } from '~/types';

export const ErrorPageMainContent: FC<ChildrenType> = ({ children }) => (
  <Box position="relative">{children}</Box>
);
